import {
  Selected,
  useConfigurableContext,
} from '@graphcommerce/magento-product-configurable'
import { useEffect } from 'react'

function ContextReceiver(props) {
  const { products, filters, setUpdate } = props

  const product = products?.items?.[0]
  let ctx = useConfigurableContext("");
  if (product?.sku) {
    ctx = useConfigurableContext(product.sku);
  }

  useEffect(() => {
    ctx.select({ ...filters } as Selected)
    setUpdate((prev) => !prev)
  }, [])

  return (
    <div />
  )
}

export default ContextReceiver
